// eslint-disable-next-line import/prefer-default-export
export const PAYROLL_STATUS = Object.freeze({
    unprocessed: 'Unprocessed',
    submitted: 'Submitted',
    pending_payment: 'Pending Payment',
    calculating: 'Calculating',
    paid: 'Paid',
    skipped: 'Skipped',
});

// Pay periods the member has settled without paying anyone. Processed, so they read as in-flight,
// but nothing is owed and nothing is left for the member to do -- never the next payroll to offer.
export const SETTLED_PAYROLL_STATUSES: readonly string[] = Object.freeze([PAYROLL_STATUS.skipped]);

/**
 * The shared content-column width (px) for payroll surfaces: the run/review takeover bodies
 * (`DetailTakeover`, `WorkerReviewShell`, `PayrollRunDialog`) and the setup-flow steps, each of
 * which centres its content in a `maxWidth: PAYROLL_CONTENT_MAX_WIDTH, mx: 'auto'` column. It is the
 * design's content measure — Figma `5507:5889`, whose summary strip, tabs and table all lay out to
 * 720. Centralised so those screens can't drift apart on the width, and so retuning it is one edit.
 */
export const PAYROLL_CONTENT_MAX_WIDTH = 720;

/** The blockers banner's copy wherever a payroll run is blocked. */
export const RUN_PAYROLL_BLOCKED_COPY = Object.freeze({
    title: 'Unable to run payroll',
    intro: 'Please resolve the following issues before submitting payroll:',
});

/** The blockers banner's copy when a skip is refused because the company is blocked. */
export const SKIP_PAYROLL_BLOCKED_COPY = Object.freeze({
    title: 'Unable to skip payroll',
    intro: 'Please resolve the following issues before skipping payroll:',
});

/**
 * How long payroll toasts stay up (ms). The app default is 3s, too short to read a toast that names
 * a pay period ("Aug 1 - Aug 14 payroll skipped") before it goes.
 */
export const PAYROLL_TOAST_DURATION_MS = 6000;
